<template>
    <h1>Titre</h1>
</template>

<script>
export default {
    name: 'WarehouseBillsPage'
}
</script>
